/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrQrRedeemResponse
 */
export interface RttrQrRedeemResponse {
    /**
     * 
     * @type {number}
     * @memberof RttrQrRedeemResponse
     */
    pointsAwarded: number;
    /**
     * 
     * @type {boolean}
     * @memberof RttrQrRedeemResponse
     */
    alreadyRedeemed: boolean;
    /**
     * 
     * @type {string}
     * @memberof RttrQrRedeemResponse
     */
    eventName: string;
    /**
     * 
     * @type {string}
     * @memberof RttrQrRedeemResponse
     */
    eventType: RttrQrRedeemResponseEventTypeEnum;
}


/**
 * @export
 */
export const RttrQrRedeemResponseEventTypeEnum = {
    minelab: 'minelab',
    club: 'club'
} as const;
export type RttrQrRedeemResponseEventTypeEnum = typeof RttrQrRedeemResponseEventTypeEnum[keyof typeof RttrQrRedeemResponseEventTypeEnum];


/**
 * Check if a given object implements the RttrQrRedeemResponse interface.
 */
export function instanceOfRttrQrRedeemResponse(value: object): value is RttrQrRedeemResponse {
    if (!('pointsAwarded' in value) || value['pointsAwarded'] === undefined) return false;
    if (!('alreadyRedeemed' in value) || value['alreadyRedeemed'] === undefined) return false;
    if (!('eventName' in value) || value['eventName'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function RttrQrRedeemResponseFromJSON(json: any): RttrQrRedeemResponse {
    return RttrQrRedeemResponseFromJSONTyped(json, false);
}

export function RttrQrRedeemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrQrRedeemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsAwarded': json['pointsAwarded'],
        'alreadyRedeemed': json['alreadyRedeemed'],
        'eventName': json['eventName'],
        'eventType': json['eventType'],
    };
}

export function RttrQrRedeemResponseToJSON(json: any): RttrQrRedeemResponse {
    return RttrQrRedeemResponseToJSONTyped(json, false);
}

export function RttrQrRedeemResponseToJSONTyped(value?: RttrQrRedeemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsAwarded': value['pointsAwarded'],
        'alreadyRedeemed': value['alreadyRedeemed'],
        'eventName': value['eventName'],
        'eventType': value['eventType'],
    };
}

